import axios from "axios";
import { ApiLink } from "../APILink/ApiLink";
import { errorAlert } from "../Components/Alerts";

export const getUnitID = async (headers) => {
  try {
    const response = await axios.get(
      ApiLink.API_URL + "UserDetails/GetUnitIDByUserID",
      { headers },
    );
    return response.data.CompanyUnit_ID || null;
  } catch (error) {
    errorAlert("Error fetching Unit:");
    return null;
  }
};

export const companyUnitDetails = async (headers, id) => {
  try {
    const response = await axios.get(
      ApiLink.API_URL + "CompanyUnits/getComUnitDetails",
      {
        headers: headers, // Sigurohu që headers janë objekt (p.sh. { Authorization: 'Bearer ...' })
        params: { id: id }, // Kjo do ta dërgojë si ?id=... në URL
      },
    );    
    return response.data || null;
  } catch (error) {
    errorAlert("Nuk mund te merren te dhenat e njesis organizative");
    return null;
  }
};

// const fetchUnId = async () => {
//     try {
//         const response = await axios.get(ApiLink.API_URL + 'UserDetails/GetUnitIDByUserID', { headers });
//         // console.log(response.data);
//         setUnID(response.data.CompanyUnit_ID);
//     } catch (error) {
//         errorAlert("Gabim në kërkesë:", error);
//         if (error.response && error.response.data && error.response.data.errorMessage) {
//             errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
//         } else if (error.message) {
//             errorAlert(`Gabim: ${error.message}`);
//         } else {
//             errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
//         }
//     }
// };
